// React
import React from 'react';

// Third party
import { BrowserRouter } from 'react-router-dom';
import { usePromiseTracker } from 'react-promise-tracker';

// Material UI
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { StylesProvider } from '@material-ui/core/styles';

// Contexts
import { AuthProvider } from '../../contexts/authProvider';

// Shared
import theme from '../../shared/theme';

// Routes
import {Routes} from '../../routes/routes';

// Components
import LoadingIndicator from '../wrapper/LoadingIndicator/LoadingIndicator';

// This component
export default function App() {
  
  // Track promises to show/hide the loading bar/icon
  const { promiseInProgress } = usePromiseTracker();

    // JSX
  return (
    
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <StylesProvider injectFirst>

          <LoadingIndicator active={promiseInProgress} />

            <BrowserRouter children={Routes} basename={"/"} />

        </StylesProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}
